{
    "Accessibility menu": "Menyu ya Ufikivu",
    "Close": "Funga",
    "Content adjustments": "Marekebisho ya Maudhui",
    "Navigation adjustments": "Marekebisho ya Uelekezaji",
    "Text Align": "Text Align",
    "Align Left": "Panga Kushoto",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Rekebisha Ukubwa wa Herufi",
    "Highlight Title": "Onesha Kichwa",
    "Highlight Links": "Onesha Viungo",
    "Readable Font": "Herufi Zinazosomeka",
    "Colour adjustments": "Marekebisho ya Rangi",
    "Dark Contrast": "Tofauti ya Giza",
    "Light Contrast": "Tofauti ya Mwangaza",
    "High Contrast": "Tofauti ya Juu",
    "High Saturation": "Ujazaji wa Juu",
    "Low Saturation": "Ujazaji wa Chini",
    "Monochrome": "Rangi Moja",
    "Tools": "Vifaa",
    "Reading Guide": "Mwongozo wa Kusoma",
    "Big Cursor": "Kishika Mkubwa",
    "Increase Font Size": "Ongeza Ukubwa wa Herufi",
    "Decrease Font Size": "Punguza Ukubwa wa Herufi",
    "Letter Spacing": "Nafasi ya Herufi",
    "Line Height": "Urefu wa Mstari",
    "Font Weight": "Uzito wa Herufi",
    "Dyslexia Font": "Herufi za Dyslexia",
    "Language": "Lugha",
    "Accessibility widget": "Fungua Menyu ya Ufikivu",
    "Accessibility Profiles": "Wasifu wa Ufikivu",
    "Cognitive Disability": "Ulemavu wa Akili",
    "Seizure Safe": "Salama kwa Mashambulizi",
    "Accessibility statement": "Taarifa ya Ufikivu",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Simamisha Animations",
    "Animation paused": "Mwendo umesimamishwa",
    "Reset all settings": "Weka upya mipangilio",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
